var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 26.46 26.46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E7CFF",
    d: "m13.23 24.8c-6.393 0-11.58-5.184-11.58-11.58 0-6.391 5.183-11.58 11.58-11.58 6.393 0 11.58 5.184 11.58 11.58 0 6.391-5.183 11.58-11.58 11.58zm0-24.8c-7.307 0-13.23 5.92-13.23 13.23 0 7.309 5.923 13.23 13.23 13.23 7.307 0 13.23-5.92 13.23-13.23 0-7.309-5.923-13.23-13.23-13.23zm5.403 12.5-4.677-4.68c-0.3233-0.3225-0.8467-0.3225-1.169 0-0.3233 0.3307-0.3233 0.8516 0 1.174l3.407 3.407h-8.753c-0.4572 0-0.8268 0.3721-0.8268 0.8268 0 0.4548 0.3696 0.8268 0.8268 0.8268h8.753l-3.407 3.407c-0.3233 0.3225-0.3233 0.8516 0 1.174 0.3225 0.3225 0.8458 0.3225 1.169 0l4.677-4.68c0.1984-0.1984 0.2604-0.4713 0.215-0.7276 0.04548-0.2563-0.01654-0.5292-0.215-0.7276z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.3b4e6031326a7460fd5e485d8d6301c1.svg";
export { ForwardRef as ReactComponent };